import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import { CarModel } from 'models/StockModel';
import { CarFormFields } from 'modules/cars/common/CarFormFields';


type CarDialogProps = {
    car: CarModel,
} & ModalActionProps<CarModel>

const CarEditDialog = (props: CarDialogProps) => {
    const {t} = useTranslation('cars');
    const [ car, setCar ] = useState(props.car);
    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        props.onFinish(car);
    };

    const change = (k: string, v: any) => setCar(old => ({...old, [k]: v}));

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <CarFormFields
                    car={car}
                    onChange={change}
                />
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('save')}</Button>
            </DialogActions>
        </Box>
    );
};

export default CarEditDialog;
